<div class="announcementsWrapper">
    <div class="homeHeader"> 
        <span class="listHeaders">
            <i class="icon icon-home_alerts"></i> 
            {{ 'HOME_ANNOUNCEMENTS_LABEL' | translate }}
            <div class="homeHeaderActionButtons"></div>
        </span>
    </div>

        <div *ngIf="!isLoading">

                <ng-container *ngIf="carouselTileItems.length > 0 then receivedAnnouncements else announcementSkeleton"> </ng-container>

                <ng-template #receivedAnnouncements>
                    <ngu-carousel #myCarousel [inputs]="carouselTile" [dataSource]="carouselTileItems">
                        <div 
                            style="padding: 20px 40px 40px 40px;background-color: #fff;"
                            *nguCarouselDef="let item"
                            class = "tileAnnounce"
                        >
                            <div class="announcementItemHeader">
                                <i class="icon icon-home_alerts"></i>
                                <h1>{{ item.title }}</h1>
                            </div>
                        
                            <div class="announcementItemContent">
                                <p>{{ item.description }} </p>
                            </div>
                        </div>
                        <ul class="myPoint" *ngIf="carouselTileItems.length > 0" NguCarouselPoint>
                            <li *ngFor="let j of myCarousel.pointNumbers; let q = index" [class.active]="j == myCarousel.activePoint"
                                (click)="myCarousel.moveTo(j)"></li>
                            <button NguCarouselPrev class="leftRs" [style.opacity]="myCarousel.isFirst ? 0.5 : 1"></button>
                            <button NguCarouselNext class="rightRs" [style.opacity]="myCarousel.isLast ? 0.5 : 1"></button>
                        </ul>
                    </ngu-carousel>
                </ng-template>
                <ng-template #announcementSkeleton>
                    <div class="announcementItemHeaderOnError">
                        <h1>{{ 'HOME_ANNOUNCEMENTS_NO_ANNOUNCEMENTS_LABEL' | translate }}</h1>
                    </div>
                
                    <div class="announcementItemContent">
                        <p></p>
                    </div>
                </ng-template>
        </div>
</div>